import { useEffect } from "react"
import { useLocation } from "react-router-dom"

const GA_MEASUREMENT_ID = "G-XS56SD8BHH";

export default function Analytics() {
   const location = useLocation()

    useEffect(() => {
        if (!window.gtag) return;

        if (window.location.origin.indexOf('-dev.') > 0 &&
            window.location.origin.indexOf('-test.') > 0)
            return

        window.gtag("config", GA_MEASUREMENT_ID, {
          page_path: location.pathname + location.search,
          page_location: window.location.href,
          page_title: document.title,
        })
    }, [location])

    return null
}